export const views = {
  waitingRoom: 'waitingRoom',
  callRoom: 'callRoom',
  faceId: 'faceId'
}